import { Dumbbell, Weight, Warehouse, Footprints } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@shared/ui';

interface FeatureProps {
  icon: JSX.Element;
  title: string;
  description: string;
}

const features: FeatureProps[] = [
  {
    icon: <Dumbbell />,
    title: 'Free Weights',
    description: 'Build strength and muscle with a wide range of free weights.',
  },
  {
    icon: <Weight />,
    title: 'Plate Loaded, Selectorized Machines',
    description: 'Experience precision and safety with our top-notch machines.',
  },
  {
    icon: <Warehouse />,
    title: 'Indoor Turf',
    description: 'Enhance your workouts with our versatile indoor turf area.',
  },
  {
    icon: <Footprints />,
    title: 'Cardio & Conditioning',
    description:
      'Improve your fitness with diverse cardio and conditioning options.',
  },
];

export const Features = () => {
  return (
    <section id="features" className="container py-24 text-center sm:py-32">
      <h2 className="text-3xl font-bold md:text-4xl ">
        <span className="bg-gradient-to-b from-primary/60 to-primary bg-clip-text text-transparent">
          Equipment{' '}
        </span>
        And{' '}
        <span className="bg-gradient-to-b from-primary/60 to-primary bg-clip-text text-transparent">
          Amenities
        </span>
      </h2>
      <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        {features.map(({ icon, title, description }: FeatureProps) => (
          <Card key={title} className="bg-muted/50">
            <CardHeader>
              <CardTitle className="grid place-items-center gap-4">
                {icon}
                {title}
              </CardTitle>
              <CardContent>{description}</CardContent>
            </CardHeader>
          </Card>
        ))}
      </div>
    </section>
  );
};
